module.exports = __webpack_public_path__ + "img/15.02eca67a.jpg";